import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import '../assets/css/dialpad.css'
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faTimes,faArrowLeft,faBackspace } from '@fortawesome/free-solid-svg-icons'; // Import the icon for the clear button
import Comtemplete from './comtemplete';
import { setshowcalllogpage } from '../redux/backgroundpermission/permission-action';


const Dialpad = () => {
  
   const dispatch = useDispatch();
  const [dial, setDial] = useState('')
  const [closepopop, setClosepopop] = useState(true);
  const setDialFun = (number) => {
    
    const num = dial + '' + number
    setDial(num)

  }
  const handleInputChange = (e) => {
    const value = e.target.value;
    const validatedValue = value.replace(/[^0-9*#]/g, ''); // Remove non-numeric characters except * and #
    setDial(validatedValue);
  }


  const dialcall = () => {
     let data ={
       
         number:dial
     }
    window.postMessage({  type:'Manual', data: data });

  }

  const slicenumber = () => {
    setDial(dial.slice(0, -1));
  }
 

  return (
 
      <div className="dialpad">
      {/* <button className="dial-button" onClick={toggleBack}>
                <FontAwesomeIcon style={{ color: '#fff', fontSize: '15px' }} icon={faArrowLeft} />
            </button> */}
       
        <div className='pad-shownumber'>
          <Form.Control
            type="text"
            value={dial}
            className="pad"
            onChange={handleInputChange}
          />
        </div>
        <div className="dialpad_sub_container">



          <div className="dialnumber">
            <div>
              <span onClick={() => setDialFun(1)}>1</span>
              <span onClick={() => setDialFun(2)}>2</span>
              <span onClick={() => setDialFun(3)}>3</span>
            </div>
            <div>
              <span onClick={() => setDialFun(4)}>4</span>
              <span onClick={() => setDialFun(5)}>5</span>
              <span onClick={() => setDialFun(6)}>6</span>
            </div>
            <div>
              <span onClick={() => setDialFun(7)}>7</span>
              <span onClick={() => setDialFun(8)}>8</span>
              <span onClick={() => setDialFun(9)}>9</span>
            </div>
            <div>
              <span onClick={() => setDialFun('*')}>*</span>
              <span onClick={() => setDialFun(0)}>0</span>
              <span onClick={() => setDialFun('#')}>#</span>
            </div>
            <div>
              
                <button className="call-button" onClick={dialcall} disabled={dial.length < 3}>
                  <FontAwesomeIcon style={{ color: '#fff', fontSize: '15px', textAlign: 'center' }} icon={faPhone} />
                </button>
            

              <div >
                
                <FontAwesomeIcon style={{ color: '#3498db', fontSize: '15px' }} icon={faBackspace} onClick={slicenumber} />
              </div>


            </div>


          </div>
          <div>



          </div>
        </div>
      </div>
     
   
  )

};

export default Dialpad;










